import services from '@/config/services'

export default class FattureAcquistoService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getControlloFattureAcquisto(year){
    let items = []
    const url = `${this.baseUrl}/utility/controllo-fatture-acquisto/${year}`
    try {
      let res =  await this.http.get(url)
      items = res.data;
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-success')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items
        }
    }

  }



  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/acquisto/fatture/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      res.data.map((el) => {
        el.totale_fattura =  parseFloat((el.totale_fattura ).toFixed(2))
        el.pagato =  parseFloat((el.pagato).toFixed(2))
        el.saldo =  parseFloat((el.totale_fattura - el.pagato).toFixed(2))

        if( (el.dilazione == null)){
          el.dilazione = false
        }else{
          el.dilazione = true
        }
      })

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }

  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'stato',
        label: 'Stato',
        type: {
          isCalculable: true
        },
        default: true,
      },
      {
        property: 'has_detail',
        label: 'Dettaglio Fatt.',
        type: {
          isBoolean: true
        },
        default: true,
        sortable: true,
      },
      {
        property: 'partitario',
        label: 'Partitario',
        default: true,
        sortable: true,
      },
      {
        property: 'numero',
        label: 'Numero Fattura',
        default: true,
        sortable: true,
      },
      {
        property: 'fornitore',
        label: 'Fornitore',
        default: true,
        sortable: true,
      },
      {
        property: 'data_emissione',
        label: 'Data Emissione',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_scadenza',
        label: 'Data Scadenza',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_registrazione',
        label: 'Data Registrazione',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_pagamento',
        label: 'Data Pagamento',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'protocollo',
        label: 'Protocollo',
        default: true,
        sortable: true,
      },
      {
        property: 'tipo_pagamento',
        label: 'Tipo Pagamento',
        default: true,
        sortable: true,
      },
      {
        property: "imponibile",
        label: "Imponibile",
        type: {
          isCurrency:true
        },
      },
      {
        property: "iva",
        label: "Importo IVA",
        type: {
          isCurrency:true
        },
      },
      {
        property: "totale_fattura",
        label: "Importo Fattura",
        sortable: true,
        type: {
          isCurrency:true
        },
        default: true,
      },
      {
        property: "pagato",
        label: "Importo Pagato",
        sortable: true,
        type: {
          isCurrency:true
        },
        default: true,
      },
      {
        property: "saldo",
        label: "Saldo",
        sortable: true,
        type: {
          isCurrency:true
        },
        default: true,
      },
    ]
  }

  async getDettaglioFattura(id){
    let item = {}

    const url = `${this.baseUrl}/acquisto/fatture/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async deletePagamento(idFattura, idPagamento){
    let item = {}
    let success = false
    let message = ''
    let status = 0

    const url = `${this.baseUrl}/acquisto/fatture/${idFattura}/pagamenti/${idPagamento}`
    try {
      let res = await this.http.delete(url)
      res = res.data
      item = res.data
      success = res.meta?.success ?? false
      status = res.meta?.status?.code ?? 200
      message = res.data?.message || res.data?.error || res.meta?.message || ''
    } catch (err) {
      const payload = err?.response?.data
      status = err?.response?.status || payload?.meta?.status?.code || 500
      success = false
      item = payload?.data || {}
      message = payload?.data?.error || payload?.data?.message || payload?.meta?.message || ''
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success,
        message,
        status,
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/acquisto/fatture/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async getInfoFattureGrezze(numeroFattura, page = 1, perPage = 10) {
    const url = `${this.baseUrl}/acquisto/fatture/grezze/${numeroFattura}?page=${page}&per_page=${perPage}`
    try {
      let res = await this.http.get(url)
      return res.data.data || {
        fatture_grezze_cei_ee: { data: [], pagination: { total: 0 } },
        fatture_grezze_cei_gas: { data: [], pagination: { total: 0 } },
        fatture_grezze_edistribuzione: { data: [], pagination: { total: 0 } }
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }


}
